import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { UpdateInventoryCategoryFormData } from "../schema/UpdateInventoryCategorySchema";
import { InventoryCategoryResponseSchema } from "../response/UpdateInventoryCategoryResponse";

export const useUpdateInventoryCategory = () => {
    return useMutation({
        mutationFn: async (values: {
            inventoryCategoryId: string;
            formData: UpdateInventoryCategoryFormData;
        }) => privateApi.put(`/v4/inventory-category/${values.inventoryCategoryId}`, values.formData),
        onSuccess: async (response) => {
            try {
                const validationResult = InventoryCategoryResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid update inventory category data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update inventory category', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid inventory category data format");
            } else {
                console.error('Failed to update inventory category', error);
                throw error;
            }
        },
    });
};
